export const sortingList = [
  {
    label: "Latest",
    sort: {
      whom: "_id",
      order: "desc",
    },
  },
  {
    label: "Oldest",
    sort: {
      whom: "_id",
      order: "asc",
    },
  },
  {
    label: "A-Z",
    sort: {
      whom: "title",
      order: "asc",
    },
  },
  {
    label: "Z-A",
    sort: {
      whom: "title",
      order: "desc",
    },
  },
];
export const sortingAPIList = [
  {
    label: "Latest",
    sort: {
      whom: "_id",
      order: "desc",
    },
  },
  {
    label: "Oldest",
    sort: {
      whom: "_id",
      order: "asc",
    },
  },
  {
    label: "A-Z",
    sort: {
      whom: "originUrl",
      order: "asc",
    },
  },
  {
    label: "Z-A",
    sort: {
      whom: "originUrl",
      order: "desc",
    },
  },
];

export const sortingNameList = [
  {
    label: "Latest",
    sort: {
      whom: "_id",
      order: "desc",
    },
  },
  {
    label: "Oldest",
    sort: {
      whom: "_id",
      order: "asc",
    },
  },
  {
    label: "A-Z",
    sort: {
      whom: "firstName",
      order: "asc",
    },
  },
  {
    label: "Z-A",
    sort: {
      whom: "firstName",
      order: "desc",
    },
  },
];
export const sortingReferCodeList = [
  {
    label: "Latest",
    sort: {
      whom: "_id",
      order: "desc",
    },
  },
  {
    label: "Oldest",
    sort: {
      whom: "_id",
      order: "asc",
    },
  },
  {
    label: "A-Z",
    sort: {
      whom: "bankAccount.accountHolderName",
      order: "asc",
    },
  },
  {
    label: "Z-A",
    sort: {
      whom: "bankAccount.accountHolderName",
      order: "desc",
    },
  },
];

export const sortingRoleameList = [
  {
    label: "Latest",
    sort: {
      whom: "_id",
      order: "desc",
    },
  },
  {
    label: "Oldest",
    sort: {
      whom: "_id",
      order: "asc",
    },
  },
  {
    label: "A-Z",
    sort: {
      whom: "name",
      order: "asc",
    },
  },
  {
    label: "Z-A",
    sort: {
      whom: "name",
      order: "desc",
    },
  },
];
export const sortingCodeList = [
  {
    label: "Latest",
    sort: {
      whom: "_id",
      order: "desc",
    },
  },
  {
    label: "Oldest",
    sort: {
      whom: "_id",
      order: "asc",
    },
  },
  {
    label: "A-Z",
    sort: {
      whom: "code",
      order: "asc",
    },
  },
  {
    label: "Z-A",
    sort: {
      whom: "code",
      order: "desc",
    },
  },
];
export const sortingEmailList = [
  {
    label: "Latest",
    sort: {
      whom: "_id",
      order: "desc",
    },
  },
  {
    label: "Oldest",
    sort: {
      whom: "_id",
      order: "asc",
    },
  },
  {
    label: "A-Z",
    sort: {
      whom: "email",
      order: "asc",
    },
  },
  {
    label: "Z-A",
    sort: {
      whom: "email",
      order: "desc",
    },
  },
];
export const sortingIdList = [
  {
    label: "Latest",
    sort: {
      whom: "_id",
      order: "desc",
    },
  },
  {
    label: "Oldest",
    sort: {
      whom: "_id",
      order: "asc",
    },
  },
];
export const subscriptionType = [
  {
    label: "Email",
    value: JSON.stringify({ emailType: true }),
  },
  {
    label: "Phone",
    value: JSON.stringify({ phoneType: true }),
  },
];
